// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import sentryOptions from '@otovo/shared/lib/sentry/sentryOptions';

import('@sentry/nextjs').then((Sentry) => {
  Sentry.init(sentryOptions);
});
